module.exports = __webpack_public_path__ + "static/media/show-data.18a09fa3.png";